import { Link } from "react-router-dom";
import { useT } from "../i18n";


function Footer(props) {
  const t = useT();
  return (

    <div className="footer">
      <div className="info_wrap">
        <div className="left_wrap">
          <div className="logo_image">
            <img src={process.env.PUBLIC_URL + "images/logo_footer.svg"} alt={t("프롭메이트 로고")} />
          </div>
          <div className="copyright">
            <div className="copyright_text">
              2025ⓒ PROPMATE INC. All Rights Reserved.
            </div>
            <div className="copyright_text reverse">
              2025ⓒ PROPMATE INC. All Rights Reserved.
            </div>
          </div>
        </div>
        <div className="right_wrap">
          <div className="info_text">
            <div className="address">
              37º479365"N 126º930869"E
            </div>
            <div className="ceo">{t("대표이사 | 고 호 준")}</div>
            <div className="privacy">{t("개인정보 관리 책임자 | 이 형 우")}</div>
            <div className="business_number">{t("사업자등록번호 | 469-81-03262")}</div>
            <div className="link_wrap">
              <Link to={'/agree'} state={{ index: 0 }}>{t("이용약관")}</Link> |
              <Link to={'/agree'} state={{ index: 1 }}> {t("개인정보처리방침")}</Link> |
              <Link to={'/agree'} state={{ index: 2 }}> {t("위치기반 서비스 이용약관")}</Link>
            </div>
            <div className="mobile-copyright_text">
              2025ⓒ PROPMATE INC. All Rights Reserved.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer;